define('shared/util/Math',[],function(){
    var preferredCulture = navigator.languages && navigator.languages[0] || 
        navigator.language || 
        navigator.browserLanguage;
    var preferredLanguage = preferredCulture.split('-')[0];

    function Math(){

    }

    Math.prototype = this.Math;

    var math = new Math();

    function toCurrency(num, fixedLength, formatFloat){
        var separator = ',';
        var formated = num + '';
        var floatIndex = formated.indexOf('.');
        var chars = formated.split('');
        var result = [];
        var delimiterIndex, len = chars.length, fixedCounter=0, tmpChar;
        
        if (floatIndex < 0){
            // means the dot actually is at the end of the string
            floatIndex = len;
        }
        
        for(var i = 0; i < len; i++){
            // don't put commas to the end
            if (i > len - 1 || 
                (fixedLength != null && i > fixedLength + floatIndex)
                ) continue;
                
            tmpChar = chars[i];
            if (i < floatIndex - 1 ){
                delimiterIndex = (floatIndex - 1 - i);
                if (delimiterIndex !== 0 && delimiterIndex % 3 === 0){
                    tmpChar = chars[i] + separator;
                }

            }
            else if (formatFloat && i > floatIndex - 1){
                
                if (fixedCounter++ <= fixedLength){
                    delimiterIndex = (i - floatIndex);
                    if (delimiterIndex !== 0 && delimiterIndex % 3 === 0 &&
                        // check it is not the last char
                        i < fixedLength + floatIndex){
                        tmpChar = chars[i] + separator;
                    }
                }

            }

            result.push(tmpChar);
        }
        
        if (result[result.length - 1] == '.' ) {
            result.pop();
        }
        
        formated = result.join('');

        if (
            preferredLanguage === 'it' || 
            preferredLanguage === 'de' || 
            preferredLanguage === 'fr'
        ) {
            formated = formated.replace(/\,/g, '.');
        }
        
        return formated;
    }

    math.currency = toCurrency;

    return math;
});
